import React, { useEffect, useState } from "react";
import HomeAdminTemplate from "../../../../../presentation/pages/admin/home";
import { makeRemoteSolicitation } from "../../../usecases/solicitation/remote-solicitation-factory";

function MakeHomeAdmin(): JSX.Element {
  const [count, setCount] = useState<number>();
  useEffect(() => {
    (async () => {
      const countData = await makeRemoteSolicitation().count();
      setCount(countData);
    })();
  }, []);
  return <HomeAdminTemplate count={count} />;
}

export default MakeHomeAdmin;
